// removed by extract-text-webpack-plugin
module.exports = {"chrome":"AdQzk","container":"UD191","aside":"t9qTE"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/Chrome/styles.css
 ** module id = 338
 ** module chunks = 0
 **/